<header class="header" [ngClass]="[fixedHeader ? 'fixed' : '']">
  <span
    class="applications"
    id="applications"
    (click)="toggleApplicationList()"
    [ngClass]="[disableEdit ? 'disableEdit' : '']"
  >
    <div class="grc">
      <fa-icon [icon]="faGrid" class="grid"></fa-icon></div
  ></span>
  <div class="applicationList" *ngIf="showApplications">
    <app-application-list
      (click)="closeApplicationList($event)"
    ></app-application-list>
  </div>

  <span class="logo"> <img src="/assets/images/logo.jpeg" /> </span>

  <span class="search" *ngIf="false"
    ><img
      src="/assets/images/header/search.png"
      style="vertical-align: middle; margin-right: 10px; margin-left: 10px"
    /><ng-container>Search Quantivate</ng-container></span
  >
  <span class="user" id="userInfo" [ngClass]="{ admin: adminAccess }">
    <ng-container *ngIf="false">
      <span class="header_icon" id="alertsIcon"
        ><fa-icon [icon]="faBell"></fa-icon>Alerts</span
      >
    </ng-container>
    <span
      class="header_icon detailsmall"
      id="feedbackIcon"
      (click)="productFeedback('feedbackIcon', $event, canvasType)"
      ><fa-icon [icon]="faMessageLines"></fa-icon>Feedback</span
    >
    <span class="header_icon" id="helpIcon"
      ><fa-icon
        [icon]="faCircleQuestion"
        [matMenuTriggerFor]="helpMenu"
      ></fa-icon
      >Help</span
    >
    <ng-container *ngIf="adminAccess && (enablePublishing || enableCMS)">
      <span
        [matMenuTriggerFor]="settingsMenu"
        class="header_icon"
        id="settingsIcon"
        ><fa-icon [icon]="faGear"></fa-icon>Settings</span
      >
    </ng-container>
    <div class="avatar-circle" [matMenuTriggerFor]="profileMenu">
      <span class="initials">{{ getInitials(user_name) }}</span>
    </div>
  </span>
  <span class="help"> </span>
  <span class="icons" [ngClass]="[disableEdit ? 'disableEdit' : '']">
    <ng-container *ngIf="canvasMode == 'edit'">
      <span
        class="header_icon"
        id="saveIcon"
        (click)="saveCanvas('saveIcon')"
        *ngIf="hasEdit && canvasAccess"
        ><fa-icon [icon]="faSave"></fa-icon>Save</span
      >
      <span
        class="header_icon"
        id="editReportIcon"
        *ngIf="
          canvasMode == 'edit' && canvasType == 'dashboard' && canvasLayout
        "
        (click)="editAsReport('editReportIcon')"
        ><fa-icon [icon]="faArrowLeftToLine"></fa-icon>Charts</span
      >
      <span
        class="header_icon"
        id="editReportIcon"
        *ngIf="
          canvasMode == 'edit' && canvasType == 'dashboard' && !canvasLayout
        "
        (click)="editAsLayout('editReportIcon')"
        ><fa-icon [icon]="faArrowRightToLine"></fa-icon>Layout</span
      >
      <span
        class="header_icon left_end"
        id="viewIcon"
        (click)="viewCanvas('viewIcon')"
        ><fa-icon [icon]="faEye"></fa-icon>Preview</span
      >
      <span class="header_icon" id="moreIcon" [matMenuTriggerFor]="headerMenu"
        ><fa-icon [icon]="faEllipsis"></fa-icon>More</span
      >
    </ng-container>

    <ng-container *ngIf="canvasMode == 'view'">
      <span
        class="header_icon left_end"
        id="exportIcon"
        (click)="exportReport('exportIcon')"
        *ngIf="
          canvasMode != 'index' &&
          canvasMode != 'publish' &&
          canvasMode != 'cms' &&
          canvasMode != 'schedule' &&
          canvasMode != 'marketing' &&
          canvasMode != 'blank'
        "
        ><fa-icon [icon]="faDownload"></fa-icon>Export</span
      >
      <span
        class="header_icon left_end"
        id="editIcon"
        *ngIf="hasEdit && canvasAccess"
        (click)="editCanvas('editIcon')"
        ><fa-icon [icon]="faEdit"></fa-icon>Edit</span
      >
      <span
        class="header_icon"
        id="saveIcon"
        (click)="saveCanvas('saveIcon')"
        *ngIf="hasEdit && canvasAccess"
        ><fa-icon [icon]="faSave"></fa-icon>Save</span
      >

      <span
        class="header_icon"
        id="moreIcon"
        [matMenuTriggerFor]="viewHeaderMenu"
        ><fa-icon [icon]="faEllipsis"></fa-icon>More</span
      >
    </ng-container>

    <span
      class="header_icon detailsmall create"
      id="createReport"
      (click)="openCreateDialog()"
      *ngIf="canvasMode == 'index'"
      ><fa-icon [icon]="faPlus"></fa-icon>
      <span class="createText">Create</span></span
    >
    <span
      class="header_icon detailsmall create publish"
      id="publisheReport"
      (click)="publishReports('publishIcon')"
      *ngIf="canvasMode == 'publish'"
      ><fa-icon [icon]="faUpload"></fa-icon
      ><span class="createText">Publish</span></span
    >
  </span>
</header>

<mat-menu #helpMenu="matMenu" yPosition="below" [class]="'userMenuDropdown'">
  <ng-container *ngFor="let item of helpLinks">
    <ng-container *ngFor="let menuItem of item.children.data">
      <a
        mat-menu-item
        href="{{ menuItem.url }}"
        target="{{ menuItem.meta.target }}"
        >{{ menuItem.meta.short_title || menuItem.title }}
      </a>
    </ng-container>
  </ng-container>
</mat-menu>

<mat-menu
  #settingsMenu="matMenu"
  yPosition="below"
  [class]="'userMenuDropdown'"
>
  <a
    mat-menu-item
    routerLink="/settings/publish"
    title="Publishing"
    *ngIf="enablePublishing"
    >Publishing</a
  >
  <a *ngIf="enableCMS" mat-menu-item routerLink="/settings/cms" title="CMS"
    >CMS Dashboard</a
  >
</mat-menu>

<mat-menu #profileMenu="matMenu" yPosition="below" [class]="'userMenuDropdown'">
  <ng-container *ngFor="let item of navigation">
    <ng-container *ngIf="item.meta.position == 'bottom'">
      <div class="item" *ngIf="item.children.data.length == 0">
        <a
          href="{{ item.url }}"
          target="{{ item.meta.target }}"
          style="color: white"
        >
          <button mat-menu-item>
              <fa-icon *ngIf="item.meta.icon ?? ''"
                       style="color:#1B459B"
                       [icon]="getNavigationIcon(item.meta.icon)"
                       [flip]="item.meta.flip_icon">
              </fa-icon>
              <img *ngIf="item.meta.img_src"
                    style="display:inline-block;vertical-align:-0.125em;height:1em;color:#1B459B"
                    class="icon ng-fa-icon"
                    src="{{ item.meta.img_src }}"
                    alt="{{ item.meta.short_title }}"
              />
              {{ item.meta.short_title || item.title }}
          </button>
        </a>
      </div>
    </ng-container>
  </ng-container>
</mat-menu>

<mat-menu #headerMenu="matMenu" yPosition="below" [class]="'userMenuDropdown'">
  <button mat-menu-item (click)="reportDetails('detailsIcon')">
    <fa-icon [icon]="faCircleInfo"></fa-icon>
    <span>Details</span>
  </button>
  <button mat-menu-item (click)="reportGroups(false)">
    <fa-icon [icon]="faPeopleGroup"></fa-icon>
    <span>Access</span>
  </button>
  <button mat-menu-item (click)="favoriteCanvas(canvasId, 'favoriteIcon')">
    <ng-container *ngIf="isFavorite">
      <fa-icon [icon]="faBookmark" style="color: #ff6e00 !important"></fa-icon>
      <span>Unfavorite</span>
    </ng-container>
    <ng-container *ngIf="!isFavorite">
      <fa-icon [icon]="faBookmarkOutline"></fa-icon>
      <span>Favorite</span>
    </ng-container>
  </button>

  <ng-container *ngIf="canvasType == 'dashboard'">
    <ng-container *ngIf="canvasId == enterpriseDashboardId">
      <button
        mat-menu-item
        (click)="makeDefaultDashboard(canvasId, 'favoriteIcon', false)"
      >
        <fa-icon
          [icon]="faHouseSolid"
          style="color: #ff6e00 !important"
        ></fa-icon>
        <span>Remove Home</span>
      </button>
    </ng-container>

    <ng-container *ngIf="canvasId != enterpriseDashboardId">
      <button
        mat-menu-item
        (click)="makeDefaultDashboard(canvasId, 'favoriteIcon', true)"
      >
        <fa-icon [icon]="faHouse"></fa-icon>
        <span>Set Home</span>
      </button>
    </ng-container>
  </ng-container>

  <button mat-menu-item (click)="exportReport('exportIcon')">
    <fa-icon [icon]="faDownload"></fa-icon>
    <span>Export</span>
  </button>
  <button
    mat-menu-item
    (click)="deleteCanvas('removeIcon')"
    *ngIf="hasEdit && canvasAccess"
  >
    <fa-icon [icon]="faTrash"></fa-icon>
    <span>Delete</span>
  </button>
</mat-menu>
<mat-menu
  #viewHeaderMenu="matMenu"
  yPosition="below"
  [class]="'userMenuDropdown'"
>
  <button mat-menu-item (click)="reportGroups(true)" *ngIf="!hasEdit">
    <fa-icon [icon]="faPeopleGroup"></fa-icon>
    <span>Access</span>
  </button>
  <button mat-menu-item (click)="duplicateCanvas()">
    <fa-icon [icon]="faCopy"></fa-icon>
    <span>Duplicate & Edit</span>
  </button>
</mat-menu>
